import React from 'react';
import './DetailCandidature.css';

/**
 * Skeleton plein ecran pendant le chargement : silhouette de la page (banniere SuiviHeader +
 * barre d'onglets + blocs). Memes codes que le skeleton suivi commande. Classes cand-sk*
 * (definies dans DetailCandidature.css). Partage entre DetailCandidature et sa demo.
 */
const DetailCandidatureSkeleton: React.FC = () => (
  <div className="candidature-detail-container cand-skeleton" aria-hidden="true">
    {/* Banniere : meme geometrie que SuiviHeader (back-button + h1 + h2 + sous-titre + statut). */}
    <div className="cand-sk-banner">
      <div className="cand-sk-back"><span className="cand-sk cand-sk-circle" /></div>
      <div className="cand-sk-h1"><span className="cand-sk" /></div>
      <div className="cand-sk-h2"><span className="cand-sk" /></div>
      <div className="cand-sk-subtitle"><span className="cand-sk" /></div>
      <div className="cand-sk-statusline"><span className="cand-sk" /></div>
    </div>
    <div className="suivi-de-commande-content">
      <div className="cand-sk-tabs">
        {Array.from({ length: 3 }).map((_, i) => <span key={i} className="cand-sk cand-sk-tab" />)}
      </div>
      <div className="cand-sk-content">
        <span className="cand-sk cand-sk-block" />
        <span className="cand-sk cand-sk-block" />
        <span className="cand-sk cand-sk-block cand-sk-block--lg" />
      </div>
    </div>
  </div>
);

export default DetailCandidatureSkeleton;
